import ConsentLinkSessionProvider from "../context/ConsentLinkSessionProvider";
import ConsentLinkWrapper from "../components/ConsentLinkWrapper/ConsentLinkWrapper";

export default function ConsentLinkPage() {
    return (
        <ConsentLinkSessionProvider>
            <ConsentLinkWrapper />
        </ConsentLinkSessionProvider>
    );
}
